<template>
  <div class="pt-10 pb-3">
    <v-container>
      <!-- Bulletpoints -->
      <v-row>
        <v-col cols="4">
          <v-row justify="center">
            <div>
              <v-icon :size="$vuetify.breakpoint.smAndDown ? 20 : 30" color="#007656" class="vertical-center mr-2">mdi-check-circle</v-icon>
            </div>
            <div :style="{ 'line-height': $vuetify.breakpoint.smAndDown ? '12px' : '' }">
              <span :style="{ 'font-size': $vuetify.breakpoint.smAndDown ? '10px' : '' }">Kostenfrei<br> online nutzbar</span>
            </div>
          </v-row>
        </v-col>
        <v-col cols="4">
          <v-row justify="center">
            <div>
              <v-icon :size="$vuetify.breakpoint.smAndDown ? 20 : 30" color="#007656" class="vertical-center mr-2">mdi-check-circle</v-icon>
            </div>
            <div :style="{ 'line-height': $vuetify.breakpoint.smAndDown ? '12px' : '' }">
              <span :style="{ 'font-size': $vuetify.breakpoint.smAndDown ? '10px' : '' }">Einfache<br> Anzeigenerstellung</span>
            </div>
          </v-row>
        </v-col>
        <v-col cols="4">
          <v-row justify="center">
            <div>
              <v-icon :size="$vuetify.breakpoint.smAndDown ? 20 : 30" color="#007656" class="vertical-center mr-2">mdi-check-circle</v-icon>
            </div>
            <div :style="{ 'line-height': $vuetify.breakpoint.smAndDown ? '12px' : '' }">
              <span :style="{ 'font-size': $vuetify.breakpoint.smAndDown ? '10px' : '' }">Auf allen Geräten<br> verfügbar</span>
            </div>
          </v-row>
        </v-col>
      </v-row>

      <!-- Testimonials -->
      <v-row :class="{ 'mt-10': $vuetify.breakpoint.md }">
        <v-col cols="12" md="6" :class="{ 'pt-5': $vuetify.breakpoint.md }">
          <img src="../../assets/home/Einblick_PC_Mockup.png" alt="" style="width: 100%; margin: auto; display: block">
        </v-col>
        <v-col cols="12" md="6">
          <div class="center-parent" style="height: 100%; width: 100%">
            <div class="vertical-center" :style="{ 'max-width': $vuetify.breakpoint.sm ? '500px' : '' }" style="margin: auto">
              <tradana-single-testimonial v-for="(data, i) in testimonials" :data="data" :key="i" :style="{ 'margin-bottom': $vuetify.breakpoint.smAndDown ? '10px' : '40px' }"></tradana-single-testimonial>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import SingleTestimonial from '@/components/testimonials/SingleTestimonial.vue'
export default {
  data () {
    return {
      testimonials: [
        {
          img: 'https://resources.eternio.com/static/blog/Blog_Autor_Philip.jpg',
          text: '"Wir haben uns schon immer eine Lösung gewünscht, die das Erstellen und Abstimmen mit den Angehörigen und Verlagen deutlich vereinfacht.“',
          author: 'Bestattungshaus Weber'
        },
        {
          img: 'https://resources.eternio.com/static/blog/Blog_Autor_Philip.jpg',
          text: '"Das selbst gestalten einer Traueranzeige leistet einen wichtigen Beitrag zur Trauerarbeit. Gleichzeitig wertschätzt es auch die Verstorbenen."',
          author: 'Florian Rauch, AETAS Lebens- und Trauerkultur'
        }
      ]
    }
  },
  components: {
    TradanaSingleTestimonial: SingleTestimonial
  }
}
</script>

<style scoped>
.float-left {
  float: left
}
</style>
